// Visibilis Life – Mitglieder-App i18n (DE/FR/IT/EN).
// Only the member-app namespaces are shipped here (common, member, app).
// No Control-OS translation strings are included in the standalone bundle.

const de = {
  "common": {
    "search": "Suchen",
    "filter": "Filter",
    "all": "Alle",
    "status": "Status",
    "actions": "Aktionen",
    "approve": "Genehmigen",
    "reject": "Ablehnen",
    "details": "Details",
    "logout": "Abmelden",
    "role": "Rolle",
    "language": "Sprache",
    "loading": "Wird geladen …",
    "no_data": "Keine Einträge vorhanden.",
    "open_menu": "Menü öffnen",
    "skip_to_content": "Zum Inhalt springen",
    "in_preparation": "In Vorbereitung",
    "mark_in_progress": "In Bearbeitung",
    "mark_resolved": "Als gelöst markieren",
    "view_all": "Alle anzeigen",
    "reset": "Zurücksetzen",
    "back": "Zurück",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "close": "Schliessen",
    "connection_error": "Die Verbindung ist momentan nicht verfügbar. Bitte kurz erneut versuchen.",
    "retry": "Erneut versuchen"
  },
  "member": {
    "app_name": "Visibilis Life",
    "tagline": "Gemeinschaft, Freundschaften und Teilhabe.",
    "nav": {
      "start": "Start",
      "activities": "Aktivitäten",
      "groups": "Kreise & Gruppen",
      "messages": "Nachrichten",
      "profile": "Mein Profil",
      "groups_short": "Kreise"
    },
    "login": {
      "invalid_credentials": "E-Mail-Adresse oder Passwort ist nicht korrekt.",
      "timeout": "Die Anmeldung konnte nicht bestätigt werden. Bitte prüfe deine Verbindung und versuche es erneut.",
      "staff_account": "Dieses Konto ist ein internes Teamkonto. Teamkonten melden sich im Control OS an, nicht in der Mitglieder-App.",
      "invalid_session": "Die Anmeldung hat keine gültige Mitgliedersitzung ergeben. Es wurde nichts gespeichert.",
      "env_blocked": "Die Anmeldung ist in dieser Umgebung gesperrt, weil die Konfiguration nicht passt.",
      "local_account": "Im lokalen Teststack sind nur fiktive Testadressen erlaubt (z. B. @example.com). Es wurde nichts gesendet.",
      "access_unavailable": "Die Anmeldung ist für dieses Konto derzeit nicht möglich – zum Beispiel, solange die Profilprüfung nach einer Einladung noch offen ist. Bitte kontaktiere bei Fragen den Support.",
      "too_many_attempts": "Zu viele Anmeldeversuche. Bitte warte etwas und versuche es später erneut.",
      "invalid_input": "Bitte überprüfe E-Mail-Adresse und Passwort.",
      "failed": "Die Anmeldung ist momentan nicht möglich. Bitte versuche es später erneut.",
      "title": "Willkommen zurück",
      "subtitle": "Melde dich in deiner Mitglieder-App an.",
      "email": "E-Mail-Adresse",
      "password": "Passwort",
      "submit": "Anmelden",
      "demo_hint": "Demo-Zugang (Preview)",
      "show_password": "Passwort anzeigen",
      "hide_password": "Passwort verbergen",
      "no_dating": "Visibilis Life ist keine Dating-Plattform – hier geht es um Freundschaften, Interessen und Teilhabe.",
      "preview_badge": "PREVIEW – keine echten Daten",
      "a11y_hint": "Barrierefreiheits-Einstellungen sind bereits vor dem Login verfügbar."
    },
    "not_found": {
      "title": "Seite nicht gefunden",
      "text": "Diese Seite gibt es nicht oder sie wurde verschoben.",
      "back": "Zurück zur Anmeldung"
    },
    "start": {
      "greeting": "Hallo {name}",
      "intro": "Schön, dass du da bist. Hier ist, was gerade läuft.",
      "announcements": "Neuigkeiten",
      "upcoming": "Kommende Aktivitäten",
      "suggested_groups": "Vorgeschlagene Kreise",
      "empty": "Momentan nichts Neues."
    },
    "activities": {
      "title": "Aktivitäten",
      "subtitle": "Sichere, gemeinsame Aktivitäten in deiner Nähe.",
      "join": "Teilnehmen",
      "joined": "Angemeldet",
      "leave": "Abmelden",
      "participants": "Teilnehmende",
      "capacity": "Plätze",
      "when": "Wann",
      "where": "Wo",
      "all": "Alle",
      "empty": "Keine Aktivitäten gefunden.",
      "joined_toast": "Du nimmst jetzt teil.",
      "left_toast": "Du hast dich abgemeldet."
    },
    "groups": {
      "title": "Kreise & Gruppen",
      "subtitle": "Finde Gemeinschaften mit gemeinsamen Interessen.",
      "join": "Beitreten",
      "joined": "Beigetreten",
      "leave": "Verlassen",
      "members": "Mitglieder",
      "empty": "Keine Gruppen gefunden.",
      "joined_toast": "Du bist der Gruppe beigetreten.",
      "left_toast": "Du hast die Gruppe verlassen."
    },
    "messages": {
      "title": "Nachrichten",
      "subtitle": "Freundlicher Austausch in der Gemeinschaft.",
      "empty": "Keine Unterhaltungen.",
      "placeholder": "Nachricht schreiben …",
      "send": "Senden",
      "community_note": "Bitte bleib freundlich und respektvoll.",
      "select_hint": "Wähle links eine Unterhaltung."
    },
    "p2b": {
      "tab_chats": "Chats",
      "tab_directory": "Mitglieder",
      "sec_requests": "Kontaktanfragen",
      "sec_direct": "Direktnachrichten",
      "sec_groups": "Gruppen & Community",
      "badge_request": "Anfrage",
      "badge_sent": "Gesendet",
      "dir_search_placeholder": "Mitglieder suchen …",
      "dir_search_label": "Mitglieder suchen",
      "dir_empty": "Keine Mitglieder gefunden.",
      "send_request": "Kontaktanfrage senden",
      "request_sent": "Kontaktanfrage gesendet",
      "request_received": "Anfrage erhalten",
      "open_chat": "Chat öffnen",
      "request_sent_toast": "Kontaktanfrage gesendet.",
      "request_sent_note": "Warte auf Zustimmung. Nachrichten sind erst nach Annahme möglich.",
      "request_incoming_note": "{name} möchte dich kontaktieren.",
      "accept": "Annehmen",
      "decline": "Ablehnen",
      "block": "Blockieren",
      "unblock": "Entblockieren",
      "report": "Melden",
      "accept_toast": "Kontaktanfrage angenommen.",
      "decline_toast": "Kontaktanfrage abgelehnt.",
      "block_toast": "Mitglied blockiert.",
      "unblock_toast": "Blockierung aufgehoben.",
      "blocked_title": "Blockierte Mitglieder",
      "blocked_banner": "Du hast dieses Mitglied blockiert. Es sind keine Nachrichten möglich.",
      "block_confirm_title": "{name} blockieren?",
      "block_confirm_desc": "Es können keine neuen Nachrichten oder Kontaktanfragen ausgetauscht werden. Der bestehende Chat wird nicht weitergeführt. Frühere Nachrichten werden nicht gelöscht.",
      "report_action": "{name} melden",
      "block_action": "{name} blockieren",
      "request_closed": "Diese Kontaktanfrage wurde geschlossen.",
      "report_member_title": "Mitglied melden",
      "report_member_desc": "Melde {name} an unser Team. Deine Meldung wird vertraulich behandelt.",
      "report_message_title": "Nachricht melden",
      "report_message_desc": "Melde diese Nachricht an unser Team. Deine Meldung wird vertraulich behandelt.",
      "report_reason": "Grund",
      "report_reason_placeholder": "Grund wählen",
      "report_note": "Notiz (optional)",
      "report_note_placeholder": "Zusätzliche Angaben …",
      "report_submit": "Meldung senden",
      "report_success": "Danke, deine Meldung wurde übermittelt.",
      "reason_spam": "Spam",
      "reason_harassment": "Belästigung",
      "reason_inappropriate": "Unangemessene Inhalte",
      "reason_fake": "Fake-Profil",
      "reason_other": "Sonstiges",
      "privacy_title": "Datenschutz & Privatsphäre",
      "privacy_discoverable": "Im Mitgliederverzeichnis erscheinen",
      "privacy_discoverable_note": "Wenn aktiviert, können dich andere Mitglieder im Verzeichnis finden und dir eine Kontaktanfrage senden.",
      "privacy_allow": "Kontaktanfragen erlauben",
      "privacy_allow_note": "Wenn deaktiviert, kann dir niemand neue Kontaktanfragen senden. Bestehende Chats bleiben erhalten.",
      "err_not_contactable": "Dieses Mitglied kann derzeit nicht kontaktiert werden.",
      "err_pre_accept": "Nachrichten sind erst nach Annahme der Kontaktanfrage möglich.",
      "err_not_found": "Unterhaltung nicht gefunden.",
      "err_rate": "Zu viele Anfragen oder Nachrichten. Bitte später erneut versuchen.",
      "err_cooldown": "Eine erneute Kontaktanfrage ist derzeit noch nicht möglich."
    },
    "profile": {
      "title": "Mein Profil",
      "edit": "Bearbeiten",
      "save": "Speichern",
      "cancel": "Abbrechen",
      "bio": "Über mich",
      "bio_placeholder": "Erzähle kurz etwas über dich …",
      "interests": "Interessen",
      "languages": "Sprachen",
      "city": "Ort",
      "stat_activities": "Aktivitäten",
      "stat_groups": "Gruppen",
      "access_pass": "Access Pass",
      "pass_number": "Pass-Nummer",
      "valid_until": "Gültig bis",
      "no_pass": "Kein Access Pass hinterlegt.",
      "logout": "Abmelden",
      "saved_toast": "Profil gespeichert.",
      "sections": "Einstellungen & Hilfe",
      "security": "Sicherheit",
      "security_2fa": "Zwei-Faktor-Authentifizierung",
      "security_2fa_off": "Nicht aktiviert",
      "security_2fa_on": "Aktiviert",
      "security_2fa_note": "In dieser Preview optional. Eine spätere Aktivierung ist bereits vorbereitet.",
      "help": "Hilfe",
      "help_body": "Fragen? Unser Team hilft dir gerne weiter.",
      "help_topics": "Häufige Themen: Aktivitäten, Gruppen, Sicherheit, Konto.",
      "accessibility": "Barrierefreiheit",
      "high_contrast": "Hoher Kontrast",
      "large_text": "Grosse Schrift",
      "reduce_motion": "Weniger Bewegung",
      "accessibility_note": "Einstellungen für bessere Lesbarkeit und Bedienung.",
      "accessibility_reset": "Auf Systemvorgaben zurücksetzen",
      "accessibility_reset_toast": "Barrierefreiheit auf Systemvorgaben zurückgesetzt.",
      "accessibility_reset_confirm": "Barrierefreiheits-Einstellungen auf die Systemvorgaben zurücksetzen?",
      "accessibility_reset_desc": "Deine persönliche Auswahl wird entfernt. Danach gelten wieder die Systemvorgaben deines Geräts.",
      "account": "Konto",
      "account_email": "E-Mail",
      "account_note": "Demo-Konto – keine echten Daten, keine echten E-Mails.",
      "notifications": "Benachrichtigungen"
    },
    "categories": {
      "soziales": "Soziales",
      "sport": "Sport",
      "kultur": "Kultur",
      "bildung": "Bildung",
      "freizeit": "Freizeit",
      "regional": "Regional"
    }
  },
  "app": {
    "name": "Visibilis Life",
    "env_preview": "PREVIEW"
  }
};

const en = {
  "common": {
    "search": "Search",
    "filter": "Filter",
    "all": "All",
    "status": "Status",
    "actions": "Actions",
    "approve": "Approve",
    "reject": "Reject",
    "details": "Details",
    "logout": "Sign out",
    "role": "Role",
    "language": "Language",
    "loading": "Loading …",
    "no_data": "No entries.",
    "open_menu": "Open menu",
    "skip_to_content": "Skip to content",
    "in_preparation": "In preparation",
    "mark_in_progress": "In progress",
    "mark_resolved": "Mark resolved",
    "view_all": "View all",
    "reset": "Reset",
    "back": "Back",
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "connection_error": "The connection is currently unavailable. Please try again shortly.",
    "retry": "Try again"
  },
  "member": {
    "app_name": "Visibilis Life",
    "tagline": "Community, friendships and participation.",
    "nav": {
      "start": "Home",
      "activities": "Activities",
      "groups": "Circles & Groups",
      "messages": "Messages",
      "profile": "My profile",
      "groups_short": "Circles"
    },
    "login": {
      "invalid_credentials": "Email address or password is incorrect.",
      "staff_account": "This is an internal team account. Team accounts sign in to Control OS, not to the member app.",
      "invalid_session": "Sign-in did not return a valid member session. Nothing was stored.",
      "env_blocked": "Sign-in is locked in this environment because the configuration does not match.",
      "local_account": "The local test stack only accepts fictitious test addresses (e.g. @example.com). Nothing was sent.",
      "access_unavailable": "Sign-in is currently unavailable for this account – for example while the profile review after an invitation is still open. Please contact support with any questions.",
      "too_many_attempts": "Too many sign-in attempts. Please wait and try again later.",
      "invalid_input": "Please check your email address and password.",
      "failed": "Sign-in is currently unavailable. Please try again later.",
      "title": "Welcome back",
      "subtitle": "Sign in to your member app.",
      "email": "Email address",
      "password": "Password",
      "submit": "Sign in",
      "demo_hint": "Demo access (preview)",
      "show_password": "Show password",
      "hide_password": "Hide password",
      "no_dating": "Visibilis Life is not a dating platform – it's about friendships, interests and participation.",
      "preview_badge": "PREVIEW – no real data",
      "a11y_hint": "Accessibility settings are available even before login."
    },
    "not_found": {
      "title": "Page not found",
      "text": "This page does not exist or has been moved.",
      "back": "Back to sign in"
    },
    "start": {
      "greeting": "Hi {name}",
      "intro": "Glad you're here. Here's what's happening.",
      "announcements": "News",
      "upcoming": "Upcoming activities",
      "suggested_groups": "Suggested circles",
      "empty": "Nothing new right now."
    },
    "activities": {
      "title": "Activities",
      "subtitle": "Safe, shared activities near you.",
      "join": "Join",
      "joined": "Joined",
      "leave": "Leave",
      "participants": "Participants",
      "capacity": "Spots",
      "when": "When",
      "where": "Where",
      "all": "All",
      "empty": "No activities found.",
      "joined_toast": "You're taking part now.",
      "left_toast": "You left the activity."
    },
    "groups": {
      "title": "Circles & Groups",
      "subtitle": "Find communities with shared interests.",
      "join": "Join",
      "joined": "Joined",
      "leave": "Leave",
      "members": "members",
      "empty": "No groups found.",
      "joined_toast": "You joined the group.",
      "left_toast": "You left the group."
    },
    "messages": {
      "title": "Messages",
      "subtitle": "Friendly exchange within the community.",
      "empty": "No conversations.",
      "placeholder": "Write a message …",
      "send": "Send",
      "community_note": "Please stay friendly and respectful.",
      "select_hint": "Pick a conversation on the left."
    },
    "p2b": {
      "tab_chats": "Chats",
      "tab_directory": "Members",
      "sec_requests": "Contact requests",
      "sec_direct": "Direct messages",
      "sec_groups": "Groups & community",
      "badge_request": "Request",
      "badge_sent": "Sent",
      "dir_search_placeholder": "Search members …",
      "dir_search_label": "Search members",
      "dir_empty": "No members found.",
      "send_request": "Send contact request",
      "request_sent": "Contact request sent",
      "request_received": "Request received",
      "open_chat": "Open chat",
      "request_sent_toast": "Contact request sent.",
      "request_sent_note": "Waiting for approval. Messages are only possible after acceptance.",
      "request_incoming_note": "{name} would like to contact you.",
      "accept": "Accept",
      "decline": "Decline",
      "block": "Block",
      "unblock": "Unblock",
      "report": "Report",
      "accept_toast": "Contact request accepted.",
      "decline_toast": "Contact request declined.",
      "block_toast": "Member blocked.",
      "unblock_toast": "Member unblocked.",
      "blocked_title": "Blocked members",
      "blocked_banner": "You have blocked this member. Messaging is not possible.",
      "block_confirm_title": "Block {name}?",
      "block_confirm_desc": "No new messages or contact requests can be exchanged. The existing chat will not continue. Earlier messages are not deleted.",
      "report_action": "Report {name}",
      "block_action": "Block {name}",
      "request_closed": "This contact request has been closed.",
      "report_member_title": "Report member",
      "report_member_desc": "Report {name} to our team. Your report is treated confidentially.",
      "report_message_title": "Report message",
      "report_message_desc": "Report this message to our team. Your report is treated confidentially.",
      "report_reason": "Reason",
      "report_reason_placeholder": "Choose a reason",
      "report_note": "Note (optional)",
      "report_note_placeholder": "Additional details …",
      "report_submit": "Send report",
      "report_success": "Thank you, your report has been submitted.",
      "reason_spam": "Spam",
      "reason_harassment": "Harassment",
      "reason_inappropriate": "Inappropriate content",
      "reason_fake": "Fake profile",
      "reason_other": "Other",
      "privacy_title": "Data protection & privacy",
      "privacy_discoverable": "Appear in the member directory",
      "privacy_discoverable_note": "When enabled, other members can find you in the directory and send you a contact request.",
      "privacy_allow": "Allow contact requests",
      "privacy_allow_note": "When disabled, no one can send you new contact requests. Existing chats remain.",
      "err_not_contactable": "This member cannot be contacted right now.",
      "err_pre_accept": "Messages are only possible after the contact request is accepted.",
      "err_not_found": "Conversation not found.",
      "err_rate": "Too many requests or messages. Please try again later.",
      "err_cooldown": "A new contact request is not possible yet."
    },
    "profile": {
      "title": "My profile",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "bio": "About me",
      "bio_placeholder": "Tell us a little about yourself …",
      "interests": "Interests",
      "languages": "Languages",
      "city": "City",
      "stat_activities": "Activities",
      "stat_groups": "Groups",
      "access_pass": "Access Pass",
      "pass_number": "Pass number",
      "valid_until": "Valid until",
      "no_pass": "No Access Pass on file.",
      "logout": "Sign out",
      "saved_toast": "Profile saved.",
      "sections": "Settings & help",
      "security": "Security",
      "security_2fa": "Two-factor authentication",
      "security_2fa_off": "Not enabled",
      "security_2fa_on": "Enabled",
      "security_2fa_note": "Optional in this preview. Later activation is already prepared.",
      "help": "Help",
      "help_body": "Questions? Our team is happy to help.",
      "help_topics": "Common topics: activities, groups, safety, account.",
      "accessibility": "Accessibility",
      "high_contrast": "High contrast",
      "large_text": "Large text",
      "reduce_motion": "Reduce motion",
      "accessibility_note": "Settings for better readability and use.",
      "accessibility_reset": "Reset to system defaults",
      "accessibility_reset_toast": "Accessibility reset to system defaults.",
      "accessibility_reset_confirm": "Reset accessibility settings to system defaults?",
      "accessibility_reset_desc": "Your personal selection will be removed. Your device's system defaults will apply again.",
      "account": "Account",
      "account_email": "Email",
      "account_note": "Demo account – no real data, no real emails.",
      "notifications": "Notifications"
    },
    "categories": {
      "soziales": "Social",
      "sport": "Sport",
      "kultur": "Culture",
      "bildung": "Education",
      "freizeit": "Leisure",
      "regional": "Regional"
    }
  },
  "app": {
    "name": "Visibilis Life",
    "env_preview": "PREVIEW"
  }
};

const fr = {
  "common": {
    "search": "Rechercher",
    "filter": "Filtre",
    "all": "Tous",
    "status": "Statut",
    "actions": "Actions",
    "approve": "Approuver",
    "reject": "Refuser",
    "details": "Détails",
    "logout": "Se déconnecter",
    "role": "Rôle",
    "language": "Langue",
    "loading": "Chargement …",
    "no_data": "Aucune entrée.",
    "open_menu": "Ouvrir le menu",
    "skip_to_content": "Aller au contenu",
    "in_preparation": "En préparation",
    "mark_in_progress": "En traitement",
    "mark_resolved": "Marquer résolu",
    "view_all": "Tout afficher",
    "reset": "Réinitialiser",
    "back": "Retour",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "close": "Fermer",
    "connection_error": "La connexion est momentanément indisponible. Veuillez réessayer dans un instant.",
    "retry": "Réessayer"
  },
  "member": {
    "app_name": "Visibilis Life",
    "tagline": "Communauté, amitiés et participation.",
    "nav": {
      "start": "Accueil",
      "activities": "Activités",
      "groups": "Cercles & Groupes",
      "messages": "Messages",
      "profile": "Mon profil",
      "groups_short": "Cercles"
    },
    "login": {
      "invalid_credentials": "L’adresse e-mail ou le mot de passe est incorrect.",
      "access_unavailable": "La connexion est actuellement indisponible pour ce compte – par exemple tant que la vérification du profil après une invitation est en cours. Pour toute question, veuillez contacter le support.",
      "too_many_attempts": "Trop de tentatives de connexion. Veuillez patienter et réessayer plus tard.",
      "invalid_input": "Veuillez vérifier votre adresse e-mail et votre mot de passe.",
      "failed": "La connexion est actuellement indisponible. Veuillez réessayer plus tard.",
      "title": "Bon retour",
      "subtitle": "Connecte-toi à ton app membre.",
      "email": "Adresse e-mail",
      "password": "Mot de passe",
      "submit": "Se connecter",
      "demo_hint": "Accès démo (preview)",
      "show_password": "Afficher le mot de passe",
      "hide_password": "Masquer le mot de passe",
      "no_dating": "Visibilis Life n'est pas une plateforme de rencontres – il s'agit d'amitiés, d'intérêts et de participation.",
      "preview_badge": "PREVIEW – aucune donnée réelle",
      "a11y_hint": "Les réglages d'accessibilité sont déjà disponibles avant la connexion."
    },
    "not_found": {
      "title": "Page introuvable",
      "text": "Cette page n'existe pas ou a été déplacée.",
      "back": "Retour à la connexion"
    },
    "start": {
      "greeting": "Bonjour {name}",
      "intro": "Ravi de te voir. Voici ce qui se passe.",
      "announcements": "Actualités",
      "upcoming": "Activités à venir",
      "suggested_groups": "Cercles suggérés",
      "empty": "Rien de nouveau pour l'instant."
    },
    "activities": {
      "title": "Activités",
      "subtitle": "Des activités sûres et partagées près de chez toi.",
      "join": "Participer",
      "joined": "Inscrit",
      "leave": "Se désinscrire",
      "participants": "Participants",
      "capacity": "Places",
      "when": "Quand",
      "where": "Où",
      "all": "Toutes",
      "empty": "Aucune activité trouvée.",
      "joined_toast": "Tu participes maintenant.",
      "left_toast": "Tu t'es désinscrit."
    },
    "groups": {
      "title": "Cercles & Groupes",
      "subtitle": "Trouve des communautés aux intérêts communs.",
      "join": "Rejoindre",
      "joined": "Rejoint",
      "leave": "Quitter",
      "members": "membres",
      "empty": "Aucun groupe trouvé.",
      "joined_toast": "Tu as rejoint le groupe.",
      "left_toast": "Tu as quitté le groupe."
    },
    "messages": {
      "title": "Messages",
      "subtitle": "Échanges bienveillants au sein de la communauté.",
      "empty": "Aucune conversation.",
      "placeholder": "Écrire un message …",
      "send": "Envoyer",
      "community_note": "Merci de rester bienveillant et respectueux.",
      "select_hint": "Choisis une conversation à gauche."
    },
    "p2b": {
      "tab_chats": "Discussions",
      "tab_directory": "Membres",
      "sec_requests": "Demandes de contact",
      "sec_direct": "Messages directs",
      "sec_groups": "Groupes & communauté",
      "badge_request": "Demande",
      "badge_sent": "Envoyée",
      "dir_search_placeholder": "Rechercher des membres …",
      "dir_search_label": "Rechercher des membres",
      "dir_empty": "Aucun membre trouvé.",
      "send_request": "Envoyer une demande de contact",
      "request_sent": "Demande de contact envoyée",
      "request_received": "Demande reçue",
      "open_chat": "Ouvrir la discussion",
      "request_sent_toast": "Demande de contact envoyée.",
      "request_sent_note": "En attente d'acceptation. Les messages sont possibles seulement après acceptation.",
      "request_incoming_note": "{name} souhaite te contacter.",
      "accept": "Accepter",
      "decline": "Refuser",
      "block": "Bloquer",
      "unblock": "Débloquer",
      "report": "Signaler",
      "accept_toast": "Demande de contact acceptée.",
      "decline_toast": "Demande de contact refusée.",
      "block_toast": "Membre bloqué.",
      "unblock_toast": "Membre débloqué.",
      "blocked_title": "Membres bloqués",
      "blocked_banner": "Tu as bloqué ce membre. Aucun message n'est possible.",
      "block_confirm_title": "Bloquer {name} ?",
      "block_confirm_desc": "Aucun nouveau message ou demande de contact ne pourra être échangé. La discussion existante ne se poursuivra pas. Les anciens messages ne sont pas supprimés.",
      "report_action": "Signaler {name}",
      "block_action": "Bloquer {name}",
      "request_closed": "Cette demande de contact a été fermée.",
      "report_member_title": "Signaler un membre",
      "report_member_desc": "Signale {name} à notre équipe. Ton signalement est traité de manière confidentielle.",
      "report_message_title": "Signaler un message",
      "report_message_desc": "Signale ce message à notre équipe. Ton signalement est traité de manière confidentielle.",
      "report_reason": "Motif",
      "report_reason_placeholder": "Choisir un motif",
      "report_note": "Note (facultatif)",
      "report_note_placeholder": "Informations complémentaires …",
      "report_submit": "Envoyer le signalement",
      "report_success": "Merci, ton signalement a été transmis.",
      "reason_spam": "Spam",
      "reason_harassment": "Harcèlement",
      "reason_inappropriate": "Contenu inapproprié",
      "reason_fake": "Faux profil",
      "reason_other": "Autre",
      "privacy_title": "Protection des données & confidentialité",
      "privacy_discoverable": "Apparaître dans l'annuaire des membres",
      "privacy_discoverable_note": "Si activé, d'autres membres peuvent te trouver dans l'annuaire et t'envoyer une demande de contact.",
      "privacy_allow": "Autoriser les demandes de contact",
      "privacy_allow_note": "Si désactivé, personne ne peut t'envoyer de nouvelles demandes de contact. Les discussions existantes sont conservées.",
      "err_not_contactable": "Ce membre ne peut pas être contacté pour le moment.",
      "err_pre_accept": "Les messages ne sont possibles qu'après acceptation de la demande de contact.",
      "err_not_found": "Conversation introuvable.",
      "err_rate": "Trop de demandes ou de messages. Veuillez réessayer plus tard.",
      "err_cooldown": "Une nouvelle demande de contact n'est pas encore possible."
    },
    "profile": {
      "title": "Mon profil",
      "edit": "Modifier",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "bio": "À propos de moi",
      "bio_placeholder": "Parle un peu de toi …",
      "interests": "Intérêts",
      "languages": "Langues",
      "city": "Ville",
      "stat_activities": "Activités",
      "stat_groups": "Groupes",
      "access_pass": "Access Pass",
      "pass_number": "Numéro de pass",
      "valid_until": "Valable jusqu'au",
      "no_pass": "Aucun Access Pass enregistré.",
      "logout": "Se déconnecter",
      "saved_toast": "Profil enregistré.",
      "sections": "Paramètres & aide",
      "security": "Sécurité",
      "security_2fa": "Authentification à deux facteurs",
      "security_2fa_off": "Non activée",
      "security_2fa_on": "Activée",
      "security_2fa_note": "Optionnelle dans cette preview. L'activation ultérieure est déjà prête.",
      "help": "Aide",
      "help_body": "Des questions ? Notre équipe est là pour t'aider.",
      "help_topics": "Sujets fréquents : activités, groupes, sécurité, compte.",
      "accessibility": "Accessibilité",
      "high_contrast": "Contraste élevé",
      "large_text": "Grand texte",
      "reduce_motion": "Réduire les animations",
      "accessibility_note": "Réglages pour une meilleure lisibilité et utilisation.",
      "accessibility_reset": "Réinitialiser aux valeurs système",
      "accessibility_reset_toast": "Accessibilité réinitialisée aux valeurs système.",
      "accessibility_reset_confirm": "Réinitialiser les réglages d'accessibilité aux valeurs système ?",
      "accessibility_reset_desc": "Ta sélection personnelle sera supprimée. Les valeurs système de ton appareil s'appliqueront à nouveau.",
      "account": "Compte",
      "account_email": "E-mail",
      "account_note": "Compte démo – aucune donnée réelle, aucun e-mail réel.",
      "notifications": "Notifications"
    },
    "categories": {
      "soziales": "Social",
      "sport": "Sport",
      "kultur": "Culture",
      "bildung": "Éducation",
      "freizeit": "Loisirs",
      "regional": "Régional"
    }
  },
  "app": {
    "name": "Visibilis Life",
    "env_preview": "PREVIEW"
  }
};

const it = {
  "common": {
    "search": "Cerca",
    "filter": "Filtro",
    "all": "Tutti",
    "status": "Stato",
    "actions": "Azioni",
    "approve": "Approva",
    "reject": "Rifiuta",
    "details": "Dettagli",
    "logout": "Esci",
    "role": "Ruolo",
    "language": "Lingua",
    "loading": "Caricamento …",
    "no_data": "Nessuna voce.",
    "open_menu": "Apri menu",
    "skip_to_content": "Vai al contenuto",
    "in_preparation": "In preparazione",
    "mark_in_progress": "In lavorazione",
    "mark_resolved": "Segna risolto",
    "view_all": "Mostra tutto",
    "reset": "Reimposta",
    "back": "Indietro",
    "save": "Salva",
    "cancel": "Annulla",
    "close": "Chiudi",
    "connection_error": "La connessione non è al momento disponibile. Riprova tra poco.",
    "retry": "Riprova"
  },
  "member": {
    "app_name": "Visibilis Life",
    "tagline": "Comunità, amicizie e partecipazione.",
    "nav": {
      "start": "Home",
      "activities": "Attività",
      "groups": "Cerchie e Gruppi",
      "messages": "Messaggi",
      "profile": "Il mio profilo",
      "groups_short": "Cerchie"
    },
    "login": {
      "invalid_credentials": "L’indirizzo e-mail o la password non è corretto.",
      "access_unavailable": "L’accesso non è al momento disponibile per questo account. Contatta il supporto.",
      "too_many_attempts": "Troppi tentativi di accesso. Attendi e riprova più tardi.",
      "invalid_input": "Controlla il tuo indirizzo e-mail e la password.",
      "failed": "L’accesso non è al momento disponibile. Riprova più tardi.",
      "title": "Bentornato",
      "subtitle": "Accedi alla tua app membri.",
      "email": "Indirizzo e-mail",
      "password": "Password",
      "submit": "Accedi",
      "demo_hint": "Accesso demo (preview)",
      "show_password": "Mostra password",
      "hide_password": "Nascondi password",
      "no_dating": "Visibilis Life non è una piattaforma di incontri – si tratta di amicizie, interessi e partecipazione.",
      "preview_badge": "PREVIEW – nessun dato reale",
      "a11y_hint": "Le impostazioni di accessibilità sono già disponibili prima dell'accesso."
    },
    "not_found": {
      "title": "Pagina non trovata",
      "text": "Questa pagina non esiste o è stata spostata.",
      "back": "Torna all'accesso"
    },
    "start": {
      "greeting": "Ciao {name}",
      "intro": "Felici che tu ci sia. Ecco cosa sta succedendo.",
      "announcements": "Novità",
      "upcoming": "Prossime attività",
      "suggested_groups": "Cerchie suggerite",
      "empty": "Nessuna novità al momento."
    },
    "activities": {
      "title": "Attività",
      "subtitle": "Attività sicure e condivise vicino a te.",
      "join": "Partecipa",
      "joined": "Iscritto",
      "leave": "Annulla iscrizione",
      "participants": "Partecipanti",
      "capacity": "Posti",
      "when": "Quando",
      "where": "Dove",
      "all": "Tutte",
      "empty": "Nessuna attività trovata.",
      "joined_toast": "Ora partecipi.",
      "left_toast": "Hai annullato l'iscrizione."
    },
    "groups": {
      "title": "Cerchie e Gruppi",
      "subtitle": "Trova comunità con interessi comuni.",
      "join": "Unisciti",
      "joined": "Iscritto",
      "leave": "Esci",
      "members": "membri",
      "empty": "Nessun gruppo trovato.",
      "joined_toast": "Ti sei unito al gruppo.",
      "left_toast": "Hai lasciato il gruppo."
    },
    "messages": {
      "title": "Messaggi",
      "subtitle": "Scambio amichevole nella comunità.",
      "empty": "Nessuna conversazione.",
      "placeholder": "Scrivi un messaggio …",
      "send": "Invia",
      "community_note": "Per favore, resta gentile e rispettoso.",
      "select_hint": "Scegli una conversazione a sinistra."
    },
    "p2b": {
      "tab_chats": "Chat",
      "tab_directory": "Membri",
      "sec_requests": "Richieste di contatto",
      "sec_direct": "Messaggi diretti",
      "sec_groups": "Gruppi e community",
      "badge_request": "Richiesta",
      "badge_sent": "Inviata",
      "dir_search_placeholder": "Cerca membri …",
      "dir_search_label": "Cerca membri",
      "dir_empty": "Nessun membro trovato.",
      "send_request": "Invia richiesta di contatto",
      "request_sent": "Richiesta di contatto inviata",
      "request_received": "Richiesta ricevuta",
      "open_chat": "Apri chat",
      "request_sent_toast": "Richiesta di contatto inviata.",
      "request_sent_note": "In attesa di accettazione. I messaggi sono possibili solo dopo l'accettazione.",
      "request_incoming_note": "{name} desidera contattarti.",
      "accept": "Accetta",
      "decline": "Rifiuta",
      "block": "Blocca",
      "unblock": "Sblocca",
      "report": "Segnala",
      "accept_toast": "Richiesta di contatto accettata.",
      "decline_toast": "Richiesta di contatto rifiutata.",
      "block_toast": "Membro bloccato.",
      "unblock_toast": "Membro sbloccato.",
      "blocked_title": "Membri bloccati",
      "blocked_banner": "Hai bloccato questo membro. Non è possibile inviare messaggi.",
      "block_confirm_title": "Bloccare {name}?",
      "block_confirm_desc": "Non sarà possibile scambiare nuovi messaggi o richieste di contatto. La chat esistente non proseguirà. I messaggi precedenti non vengono eliminati.",
      "report_action": "Segnala {name}",
      "block_action": "Blocca {name}",
      "request_closed": "Questa richiesta di contatto è stata chiusa.",
      "report_member_title": "Segnala membro",
      "report_member_desc": "Segnala {name} al nostro team. La tua segnalazione è trattata in modo riservato.",
      "report_message_title": "Segnala messaggio",
      "report_message_desc": "Segnala questo messaggio al nostro team. La tua segnalazione è trattata in modo riservato.",
      "report_reason": "Motivo",
      "report_reason_placeholder": "Scegli un motivo",
      "report_note": "Nota (facoltativa)",
      "report_note_placeholder": "Dettagli aggiuntivi …",
      "report_submit": "Invia segnalazione",
      "report_success": "Grazie, la tua segnalazione è stata inviata.",
      "reason_spam": "Spam",
      "reason_harassment": "Molestie",
      "reason_inappropriate": "Contenuti inappropriati",
      "reason_fake": "Profilo falso",
      "reason_other": "Altro",
      "privacy_title": "Protezione dei dati e privacy",
      "privacy_discoverable": "Comparire nell'elenco dei membri",
      "privacy_discoverable_note": "Se attivo, altri membri possono trovarti nell'elenco e inviarti una richiesta di contatto.",
      "privacy_allow": "Consenti richieste di contatto",
      "privacy_allow_note": "Se disattivato, nessuno può inviarti nuove richieste di contatto. Le chat esistenti rimangono.",
      "err_not_contactable": "Questo membro al momento non può essere contattato.",
      "err_pre_accept": "I messaggi sono possibili solo dopo l'accettazione della richiesta di contatto.",
      "err_not_found": "Conversazione non trovata.",
      "err_rate": "Troppe richieste o messaggi. Riprova più tardi.",
      "err_cooldown": "Una nuova richiesta di contatto non è ancora possibile."
    },
    "profile": {
      "title": "Il mio profilo",
      "edit": "Modifica",
      "save": "Salva",
      "cancel": "Annulla",
      "bio": "Chi sono",
      "bio_placeholder": "Racconta qualcosa di te …",
      "interests": "Interessi",
      "languages": "Lingue",
      "city": "Città",
      "stat_activities": "Attività",
      "stat_groups": "Gruppi",
      "access_pass": "Access Pass",
      "pass_number": "Numero pass",
      "valid_until": "Valido fino al",
      "no_pass": "Nessun Access Pass registrato.",
      "logout": "Esci",
      "saved_toast": "Profilo salvato.",
      "sections": "Impostazioni e aiuto",
      "security": "Sicurezza",
      "security_2fa": "Autenticazione a due fattori",
      "security_2fa_off": "Non attivata",
      "security_2fa_on": "Attivata",
      "security_2fa_note": "Opzionale in questa preview. L'attivazione futura è già predisposta.",
      "help": "Aiuto",
      "help_body": "Domande? Il nostro team è felice di aiutarti.",
      "help_topics": "Argomenti comuni: attività, gruppi, sicurezza, account.",
      "accessibility": "Accessibilità",
      "high_contrast": "Contrasto elevato",
      "large_text": "Testo grande",
      "reduce_motion": "Riduci animazioni",
      "accessibility_note": "Impostazioni per una migliore leggibilità e utilizzo.",
      "accessibility_reset": "Ripristina impostazioni di sistema",
      "accessibility_reset_toast": "Accessibilità ripristinata alle impostazioni di sistema.",
      "accessibility_reset_confirm": "Ripristinare le impostazioni di accessibilità ai valori di sistema?",
      "accessibility_reset_desc": "La tua selezione personale verrà rimossa. Verranno applicati di nuovo i valori di sistema del dispositivo.",
      "account": "Account",
      "account_email": "E-mail",
      "account_note": "Account demo – nessun dato reale, nessuna e-mail reale.",
      "notifications": "Notifiche"
    },
    "categories": {
      "soziales": "Sociale",
      "sport": "Sport",
      "kultur": "Cultura",
      "bildung": "Formazione",
      "freizeit": "Tempo libero",
      "regional": "Regionale"
    }
  },
  "app": {
    "name": "Visibilis Life",
    "env_preview": "PREVIEW"
  }
};

export const translations = { de, en, fr, it };

export const LANGUAGES = [
  {
    "code": "de",
    "label": "Deutsch"
  },
  {
    "code": "fr",
    "label": "Français"
  },
  {
    "code": "it",
    "label": "Italiano"
  },
  {
    "code": "en",
    "label": "English"
  }
];
